import { Button, ButtonColors } from '@chiroup/components/Button';
import { OpenClosedStates } from '@chiroup/components/states';
import { Marketing } from '@chiroup/core/types/Marketing.type';
import dayjs from 'dayjs';
import React from 'react';
import useMarketing from '../../hooks/useMarketing';
import List from '../common/list/List';
import ListItem from '../common/list/ListItem';
import SectionContainer from '../layout/SectionContainer';
import SectionHeader from '../layout/SectionHeader';
import MarketingCreateModal from './MarketingCreateModal';

const MarketingComponent = () => {
  const [state, setState] = React.useState<OpenClosedStates>(OpenClosedStates.Closed);
  const [selectedMarketingItem, setSelectedMarketingItem] = React.useState<Marketing | null>(null);
  const { data, isFetching, refetch, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useMarketing();

  return (
    <>
      <SectionContainer className="sm:shadow border border-gray-300 dark:border-dark-gray-800 mx-6">
        <SectionHeader
          title={'Marketing'}
          rightSide={
            <Button
              text="Add"
              color={ButtonColors.plainWithBorder}
              className="cursor-pointer"
              onClick={() => setState(OpenClosedStates.Open)}
            />
          }
        />
        <List
          isFetching={isFetching}
          fetchNextPage={fetchNextPage}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
        >
          {data?.pages?.map((page, pageNumber) => (
            <React.Fragment key={`users-page-${pageNumber}`}>
              {page?.data?.map(row => (
                <ListItem index={row.id}>
                  <div
                    className="flex items-center justify-between space-x-4 cursor-pointer"
                    onClick={() => {
                      setSelectedMarketingItem(row);
                      setState(OpenClosedStates.Open);
                    }}
                  >
                    <div className="hidden sm:flex flex-col shrink-0 items-end space-y-3">
                      <div>
                        <span className="text-gray-500 text-sm leading-4">
                          Delivery Date:&nbsp;
                        </span>
                        <span className="text-gray-500 text-sm leading-4">
                          {dayjs(row.deliveryDate as Date).format('MMM YYYY')}
                        </span>
                      </div>
                    </div>
                  </div>
                </ListItem>
              ))}
            </React.Fragment>
          ))}
        </List>
      </SectionContainer>
      <MarketingCreateModal
        state={state}
        setState={setState}
        marketingItem={selectedMarketingItem}
        setSelectedMarketingItem={setSelectedMarketingItem}
        refetch={refetch}
      />
    </>
  );
};

export default MarketingComponent;
